import type { UIStringsOverride } from "../i18n-ui.ts";

/** Portuguese (pt) UI strings. */
export const pt: UIStringsOverride = {
  actions: {
    addToCursor: "Adicionar ao Cursor",
    addToVscode: "Adicionar ao VS Code",
    askAI: "Perguntar à IA sobre esta página",
    connectMcp: "Ligar ao MCP",
    copied: "Copiado!",
    copyClaudeCode: "Copiar comando do Claude Code",
    copyCode: "Copiar código",
    copyCodex: "Copiar comando do Codex",
    copyMarkdown: "Copiar como Markdown",
    copyServerUrl: "Copiar URL do servidor",
    edit: "Editar no GitHub",
    export: "Exportar",
    exportEpub: "Exportar para EPUB",
    exportPdf: "Exportar para PDF",
    generating: "A gerar…",
    openIn: "Abrir em {name}",
    openInChat: "Abrir no chat",
    scrollToTop: "Voltar ao topo",
  },
  ask: {
    ai: "IA",
    clear: "Limpar a conversa",
    close: "Fechar",
    copy: "Copiar a conversa",
    empty: "Faça uma pergunta sobre a documentação.",
    error: "Lamentamos, algo correu mal.",
    label: "Faça uma pergunta",
    placeholder: "Faça uma pergunta…",
    send: "Enviar",
    tip: "Dica: pode abrir e fechar o chat com",
    title: "Perguntar à IA",
    you: "Você",
  },
  banner: { dismiss: "Fechar o anúncio" },
  changelog: {
    description: "Atualizações do produto e notas de lançamento.",
    showReleases: "Mostrar versões {version}",
    title: "Registo de alterações",
  },
  content: {
    diagramError: "Não foi possível apresentar este diagrama.",
  },
  feedback: {
    no: "Não",
    question: "Esta página foi útil?",
    thanks: "Obrigado pelo seu feedback!",
    yes: "Sim",
  },
  languageSwitcher: { label: "Idioma", untranslated: "Não traduzido" },
  nav: {
    back: "Voltar",
    breadcrumb: "Caminho de navegação",
    closeNavigation: "Fechar a navegação",
    deprecated: "obsoleto",
    featured: "Em destaque",
    githubRepository: "Repositório do GitHub",
    navigation: "Navegação",
    primary: "Principal",
    sections: "Secções",
    toggleNavigation: "Mostrar ou ocultar a navegação",
    toggleTheme: "Alternar o tema de cores",
  },
  notFound: {
    description: "Não encontrámos a página que procura.",
    home: "Voltar à página inicial",
    title: "Página não encontrada",
  },
  page: {
    lastUpdated: "Última atualização a",
    next: "Seguinte",
    pagination: "Paginação",
    previous: "Anterior",
    skipToContent: "Saltar para o conteúdo",
  },
  search: {
    all: "Todos",
    allLanguages: "Todos os idiomas",
    askAi: "Perguntar à IA",
    askAiHint: "Obtenha uma resposta instantânea da IA",
    button: "Pesquisar",
    devOnly: "A pesquisa está disponível na compilação de produção.",
    error: "Algo correu mal. Tente novamente.",
    label: "Pesquisar na documentação",
    navigate: "navegar",
    noResults: "Nenhum resultado encontrado.",
    open: "abrir",
    placeholder: "Pesquisar na documentação…",
    popular: "Populares",
    preview: "pré-visualizar",
    results: "Resultados",
  },
  toc: { title: "Nesta página" },
};
